<template>
  <v-layout>
      <v-row no-gutters>
        <v-col>
          <table v-if="summary" class="text-left person-info">
            <tbody>
            <tr>
              <td>Region</td>
              <td>
                <strong>{{ summary.idRegion || "No Data" }}</strong>
              </td>
            </tr>
            <tr>
              <td>Total Cases</td>
              <td>
                <strong>{{ summary.cases || "No Data" }}</strong>
              </td>
            </tr>
            <tr>
              <td>Total Staff</td>
              <td>
                <strong>{{ summary.fieldStaff }}</strong>
              </td>
            </tr>
            <tr>
              <td>Cases Not Assigned</td>
              <td>
                <strong>{{ summary.casesNotAssignedTotal }}</strong>
              </td>
            </tr>
            <tr>
              <td>Cases No Geocode</td>
              <td>
                <strong>{{ Object.keys(summary.casesNoGeocode).length || 0 }}</strong>
              </td>
            </tr>
            </tbody>
          </table>
        </v-col>
        <v-col >
          <table v-if="summary" class="text-left person-info">
            <tbody>
            <tr>
              <td>Staff Not Assigned</td>
              <td>
                <strong>{{ Object.keys(summary.staffsNotAssigned).length || 0 }}</strong>
              </td>
            </tr>
            <tr>
              <td>Estimated Task Time</td>
              <td>
                <strong>{{ summary.totalTaskTime || "No Data" }}</strong>
              </td>
            </tr>
            <tr>
              <td>Estimated Travel Time</td>
              <td>
                <strong>{{ summary.totalTravelTime || "No Data" }}</strong>
              </td>
            </tr>
            <tr>
              <td>Average Utilization</td>
              <td>
                <strong>{{ percent(summary.utilizationAvg) || "No Data" }}</strong>
              </td>
            </tr>
            <tr>
              <td>Weeks Allocated</td>
              <td>
                <strong>{{ summary.timeRequired || "No Data" }}</strong>
              </td>
            </tr>
            </tbody>
          </table>
        </v-col>
      </v-row>
  </v-layout>
</template>

<script>

export default {
  name: "RegionSummaryTable",
  props: {
    summary: Object
  },
  watch: {
    // whenever question changes, this function will run
    summary: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$props.summary = newValue;
        // this.$props.summary.utilizationAvg = this.percent(newValue.utilizationAvg);
      }
    }
  },
  methods: {
    percent (val) {
			// console.log("cht: val: ", val)
      return Number(val * 100).toFixed(0) + "%";
    }
  }
};
</script>

<style scoped>
.person-info {
  font-size: 15px;
	color: black;
}
tr:nth-child(odd) {
  /* background-color: lightblue; */
	background-color: rgb(21, 72, 124, 0.2);
}
table {
	width: 100%
}
</style>
